var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCudzyslow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 22,
    viewBox: "0 0 29 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 0L22.5455 13.8057L22.1818 10.8664C23.2727 10.8664 24.2424 11.1336 25.0909 11.668C25.9394 12.2024 26.6364 12.8853 27.1818 13.7166C27.7273 14.5479 28 15.4683 28 16.4777C28 17.4872 27.7273 18.4372 27.1818 19.3279C26.6364 20.1592 25.9394 20.8124 25.0909 21.2874C24.2424 21.7625 23.2424 22 22.0909 22C21.0606 22 20.0909 21.7625 19.1818 21.2874C18.3333 20.753 17.6364 20.0405 17.0909 19.1498C16.6061 18.2591 16.3636 17.2497 16.3636 16.1215C16.3636 14.9933 16.5758 13.8354 17 12.6478C17.4242 11.4008 18.2424 9.76789 19.4545 7.74899L23.9091 0H29ZM12.6364 0L6.18182 13.8057L5.81818 10.8664C6.90909 10.8664 7.87879 11.1336 8.72727 11.668C9.57576 12.2024 10.2727 12.8853 10.8182 13.7166C11.3636 14.5479 11.6364 15.4683 11.6364 16.4777C11.6364 17.4872 11.3636 18.4372 10.8182 19.3279C10.2727 20.1592 9.57576 20.8124 8.72727 21.2874C7.87879 21.7625 6.87879 22 5.72727 22C4.69697 22 3.72727 21.7625 2.81818 21.2874C1.9697 20.753 1.27273 20.0405 0.727273 19.1498C0.242424 18.2591 0 17.2497 0 16.1215C0 14.9933 0.212121 13.8354 0.636363 12.6478C1.06061 11.4008 1.87879 9.76789 3.09091 7.74899L7.54546 0H12.6364Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCudzyslow);
export default __webpack_public_path__ + "static/media/cudzyslow.b3713b209c57646bd55c69164abe3fac.svg";
export { ForwardRef as ReactComponent };